<span [ngbTooltip]="'Only you can view this.' | translate">
  <fa-icon icon="lock"></fa-icon>
</span>
